export default "__VITE_ASSET__BgBOyPak__"